<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Violet Lentz is a South-Korea-born, Singapore-raised, US-educated Swiss citizen. Her career in the financial and management consulting industries spans across Asia and Europe, dedicating over 24 years of time at MSCI, Merrill Lynch, Credit Suisse, Julius Baer and McKinsey. Currently, she focuses on nurturing herself, visionary companies and inspiring people. She is the co-founder and CEO of Nurturing, a company dedicated to creating a world where everyone feels loved, and nurtures one’s full potential to live a fulfilling life. She serves on the advisory board of Marmot Finance, a Swiss independent asset management firm focusing on women; and as an ambassador for Smiling Gecko, a Swiss charity organisation for Cambodians in need. She is also a certified life coach, meditation instructor, hypnotherapist and healer. She lives in Freienbach, Switzerland, with her husband, Alain Lentz.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6b44c432